import clsx from 'clsx';
import React, { DragEvent } from 'react';

import { UIChartsIcon } from '@futrli/ui-components';

import { useOnboardingContext } from '../../../../onboarding.context';
import { OnboardingArrows } from '../../onboarding-arrows/onboarding-arrows';
import { APP_WIDGET_NAMES, CARD_TYPES } from '../../../../types';
import { PERIODS } from '../../../../../forecast/detail/performance/components/period-dropdown';
import styles from './onboarding-widgets-panel.scss';
import sidebarStyles from '../../../sidebar/sidebar.scss';
import { UIChartsIconName } from '@futrli/ui-components/components/icons/custom/graph-icon';

interface OnboardingWidgetsPanelProps {
  onItemDragStart: (
    e: DragEvent<HTMLDivElement | HTMLSpanElement>,
    type: CARD_TYPES,
    data?: Record<string, unknown>
  ) => void;
}

const widgets = [
  APP_WIDGET_NAMES.CASH_IN_FROM_INVOICES,
  APP_WIDGET_NAMES.CASH_OUT_FROM_BILLS,
  APP_WIDGET_NAMES.TOP_INVOICES_DUE,
  APP_WIDGET_NAMES.TOP_BILLS_OWED,
  // APP_WIDGET_NAMES.TOP_SALES_ACCOUNTS,
  // APP_WIDGET_NAMES.TOP_COST_AND_EXPENSES_ACCOUNTS,
  // APP_WIDGET_NAMES.ACCOUNT_BRINGING_MOST_CASH,
  // APP_WIDGET_NAMES.ACCOUNTS_GREATEST_CASH_EXPENDITURE,
  APP_WIDGET_NAMES.CUSTOMERS_PAID_MOST,
  APP_WIDGET_NAMES.SUPPLIERS_YOU_PAID_MOST
];

export const OnboardingWidgetsPanel = ({ onItemDragStart }: OnboardingWidgetsPanelProps) => {
  const { isNextEnabled } = useOnboardingContext();

  return (
    <div className={styles.sidebarItemContainer}>
      <div className={clsx(styles.sidebarItemContent)}>
        <div>
          <div className={styles.appWidgetItemsContainer}>
            {widgets.map(appWidget => {
              const isDraggable = !isNextEnabled && appWidget === APP_WIDGET_NAMES.CUSTOMERS_PAID_MOST;

              return (
                <div
                  key={appWidget}
                  data-testid={`OnboardingWidgetsPanel-widget-${appWidget}`}
                  className={clsx(sidebarStyles.draggableWidget, styles.appWidgetItem, {
                    [styles.notDraggable]: !isDraggable,
                    [styles.isDimmed]: isNextEnabled || !isDraggable
                  })}
                  draggable={isDraggable}
                  onDragStart={e =>
                    onItemDragStart(e, CARD_TYPES.APP_WIDGET, {
                      name: appWidget,
                      period: PERIODS.THIS_YEAR
                    })
                  }
                >
                  <UIChartsIcon iconName={appWidget as UIChartsIconName} />
                </div>
              );
            })}
          </div>
        </div>
        <OnboardingArrows position="sidebar" />
      </div>
    </div>
  );
};
